const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/dashboards/$dashboardId/preview.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const paramsSchema = z.object({
  dashboardId: z.coerce.number().int().positive()
});

// Its own route rather than an inline component so hideChrome applies: the app's navigation
// and sidebar would otherwise sit inside the preview and misrepresent the export's layout.
export const Route = createFileRoute('/(app)/org/$org/dashboards/$dashboardId/preview')({
  params: paramsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    hideChrome: true,
    hideSidebarNav: true
  }
});